// © 2015-2021 WDNA - All Rights Reserved
import keplerGlReducer from 'kepler.gl/reducers.js';

const keplerReducer: any = keplerGlReducer
  .initialState({
    mapStyle: {
      mapStyles: {},
      styleType: 'wdna',
    },
    mapState: {
      latitude: 39.94182,
      longitude: 0.5,
      zoom: 5.8
    },
    uiState: {
      // hide side panel to disallow user customize the map
      readOnly: false,
      // side panel
      activeSidePanel: 'filter',
      // hide modal
      currentModal: null,

      // customize which map control button to show
      mapControls: {
        visibleLayers: {
          show: false,
        },
        mapLegend: {
          show: true,
          active: false,
        },
        toggle3d: {
          show: false,
        },
        splitMap: {
          show: false,
        },
        mapDraw: {
          show: false,
          active: false,
        }
      },
    },
  });
  /*
  // handle additional actions
  .plugin({
    HIDE_AND_SHOW_SIDE_PANEL: (state, action) => ({
      ...state,
      uiState: {
        ...state.uiState,
        readOnly: !state.uiState.readOnly
      }
    })
  });
  */

// export demoReducer to be combined in website app
export default keplerReducer;
